import type { FeatureFlagT } from "../proctor/FeatureFlags";

import { useContext, createContext } from "react";

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
export const FeatureFlagContext = createContext<FeatureFlagT>({} as FeatureFlagT);

export const useFeatureFlags = () => {
  return useContext(FeatureFlagContext);
};
